import { createAsyncThunk } from "@reduxjs/toolkit";
import apiCall, { getTokens } from "../AuthorizedApi";
import { getHostUrl } from "../getHostUrl";

export const createQuotationAPI = createAsyncThunk(
    'quotation/createQuotationAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'POST',
                url: `/quotation/quotations/`,
                data
            });
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getAllQuotationAPI = createAsyncThunk(
    'quotation/getAllQuotationAPI',
    async (params: { page?: number; page_size?: number; search?: string; branch_id?: number | null } | undefined, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams();
            if (params?.page) queryParams.append('page', String(params.page));
            if (params?.page_size) queryParams.append('page_size', String(params.page_size));
            if (params?.search) queryParams.append('search', params.search);
            if (params?.branch_id !== undefined && params?.branch_id !== null && params.branch_id !== ('' as any)) {
                queryParams.append('branch_id', String(params.branch_id));
            }

            const queryString = queryParams.toString();
            const url = `/quotation/quotations/${queryString ? '?' + queryString : ''}`;

            const response = await apiCall({
                method: 'GET',
                url
            });
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getQuotationByIdAPI = async (id: string | number) => {
    return apiCall({
        method: 'GET',
        url: `/quotation/quotations/${id}/`
    });
};

export const updateQuotationAPI = async (id: string | number, data: any) => {
    return apiCall({
        method: 'PUT',
        url: `/quotation/quotations/${id}/`,
        data
    });
};

export const deleteQuotationAPI = async (id: string | number) => {
    return apiCall({
        method: 'DELETE',
        url: `/quotation/quotations/${id}/`
    });
};

export const convertQuotationToOrderAPI = async (id: string | number) => {
    return apiCall({
        method: 'POST',
        url: `/quotation/quotations/${id}/convert-to-order/`
    });
};

export const updateQuotationStatusAPI = async (id: string | number, status: string) => {
    return apiCall({
        method: 'PATCH',
        url: `/quotation/quotations/${id}/status/`,
        data: { status }
    });
};

export const getQuotationNextNumberAPI = async () => {
    return apiCall({
        method: 'GET',
        url: `/quotation/quotations/next-number/`
    });
};

export const getQuotationDashboardStatsAPI = async (params?: { from_date?: string; to_date?: string; branch_id?: number | null }) => {
    const queryParams = new URLSearchParams();
    if (params?.from_date) queryParams.append('from_date', params.from_date);
    if (params?.to_date) queryParams.append('to_date', params.to_date);
    if (params?.branch_id !== undefined && params?.branch_id !== null && params.branch_id !== ('' as any)) {
        queryParams.append('branch_id', String(params.branch_id));
    }

    const queryString = queryParams.toString();
    const url = `/quotation/dashboard/stats/${queryString ? '?' + queryString : ''}`;

    return apiCall({
        method: 'GET',
        url
    });
};

const buildQueryUrl = (base: string, params?: { page?: number; page_size?: number; search?: string; branch_id?: number | null }) => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', String(params.page));
    if (params?.page_size) queryParams.append('page_size', String(params.page_size));
    if (params?.search) queryParams.append('search', params.search);
    if (params?.branch_id !== undefined && params?.branch_id !== null && params.branch_id !== ('' as any)) {
        queryParams.append('branch_id', String(params.branch_id));
    }
    const queryString = queryParams.toString();
    return `${base}${queryString ? '?' + queryString : ''}`;
};

export const getCustomersAPI = async (params?: { page?: number; page_size?: number; search?: string; branch_id?: number | null }) => {
    const url = buildQueryUrl('/quotation/customers/', params);
    return apiCall({ method: 'GET', url });
};
export const createCustomerAPI = async (data: any) => {
    return apiCall({ method: 'POST', url: '/quotation/customers/', data });
};
export const updateCustomerAPI = async (id: number, data: any) => {
    return apiCall({ method: 'PUT', url: `/quotation/customers/${id}/`, data });
};
export const deleteCustomerAPI = async (id: number) => {
    return apiCall({ method: 'DELETE', url: `/quotation/customers/${id}/` });
};

export const getProductsAPI = async (params?: { page?: number; page_size?: number; search?: string; branch_id?: number | null }) => {
    const url = buildQueryUrl('/quotation/products/', params);
    return apiCall({ method: 'GET', url });
};
export const createProductAPI = async (data: any) => {
    return apiCall({ method: 'POST', url: '/quotation/products/', data });
};
export const updateProductAPI = async (id: number, data: any) => {
    return apiCall({ method: 'PUT', url: `/quotation/products/${id}/`, data });
};
export const deleteProductAPI = async (id: number) => {
    return apiCall({ method: 'DELETE', url: `/quotation/products/${id}/` });
};

export const getFixChargesAPI = async (params?: { page?: number; page_size?: number; search?: string; branch_id?: number | null }) => {
    const url = buildQueryUrl('/quotation/fix-charges/', params);
    return apiCall({ method: 'GET', url });
};
export const createFixChargeAPI = async (data: any) => {
    return apiCall({ method: 'POST', url: '/quotation/fix-charges/', data });
};
export const updateFixChargeAPI = async (id: number, data: any) => {
    return apiCall({ method: 'PUT', url: `/quotation/fix-charges/${id}/`, data });
};
export const deleteFixChargeAPI = async (id: number) => {
    return apiCall({ method: 'DELETE', url: `/quotation/fix-charges/${id}/` });
};

export const getEmployeesAPI = async (params?: { page?: number; page_size?: number; search?: string; branch_id?: number | null }) => {
    const url = buildQueryUrl('/quotation/employees/', params);
    return apiCall({ method: 'GET', url });
};
export const createEmployeeAPI = async (data: any) => {
    return apiCall({ method: 'POST', url: '/quotation/employees/', data });
};
export const updateEmployeeAPI = async (id: number, data: any) => {
    return apiCall({ method: 'PUT', url: `/quotation/employees/${id}/`, data });
};
export const deleteEmployeeAPI = async (id: number) => {
    return apiCall({ method: 'DELETE', url: `/quotation/employees/${id}/` });
};

export const getEventTypesAPI = async (params?: { page?: number; page_size?: number; search?: string; branch_id?: number | null }) => {
    const url = buildQueryUrl('/quotation/event-types/', params);
    return apiCall({ method: 'GET', url });
};
export const createEventTypeAPI = async (data: any) => {
    return apiCall({ method: 'POST', url: '/quotation/event-types/', data });
};
export const updateEventTypeAPI = async (id: number, data: any) => {
    return apiCall({ method: 'PUT', url: `/quotation/event-types/${id}/`, data });
};
export const deleteEventTypeAPI = async (id: number) => {
    return apiCall({ method: 'DELETE', url: `/quotation/event-types/${id}/` });
};

export const getAlbumTypesAPI = async (params?: { page?: number; page_size?: number; search?: string; branch_id?: number | null }) => {
    const url = buildQueryUrl('/quotation/album-types/', params);
    return apiCall({ method: 'GET', url });
};
export const createAlbumTypeAPI = async (data: any) => {
    return apiCall({ method: 'POST', url: '/quotation/album-types/', data });
};
export const updateAlbumTypeAPI = async (id: number, data: any) => {
    return apiCall({ method: 'PUT', url: `/quotation/album-types/${id}/`, data });
};
export const deleteAlbumTypeAPI = async (id: number) => {
    return apiCall({ method: 'DELETE', url: `/quotation/album-types/${id}/` });
};

export const getAlbumPapersAPI = async (params?: { page?: number; page_size?: number; search?: string; branch_id?: number | null }) => {
    const url = buildQueryUrl('/quotation/album-papers/', params);
    return apiCall({ method: 'GET', url });
};
export const createAlbumPaperAPI = async (data: any) => {
    return apiCall({ method: 'POST', url: '/quotation/album-papers/', data });
};
export const updateAlbumPaperAPI = async (id: number, data: any) => {
    return apiCall({ method: 'PUT', url: `/quotation/album-papers/${id}/`, data });
};
export const deleteAlbumPaperAPI = async (id: number) => {
    return apiCall({ method: 'DELETE', url: `/quotation/album-papers/${id}/` });
};

export const shareQuotationOnWhatsAppAPI = async (
    quotationId: number | string,
    pdfBlob: Blob,
    filename: string
): Promise<any> => {
    const { accessToken } = getTokens();
    const form = new FormData();
    form.append("pdf", pdfBlob, filename);
    form.append("template_category", "utility");

    const response = await fetch(
        `${getHostUrl()}/quotation/quotations/${quotationId}/share-whatsapp/`,
        {
            method: "POST",
            headers: { Authorization: `Bearer ${accessToken}` },
            body: form,
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data?.message || data?.error?.message || "Share failed");
    }

    return data;
};
